/*
 * Copyright (c) 2020. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';
import { Input, Label } from '@americanexpress/dls-react';
import Typography from '../../components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

export default class BWPercentInput extends Component<any> {
    public override state = {
        error: null as string
    };

    private errorTimer!: number;

    public override render(): ReactComponentElement<any> {
        const helperText = this.props.helperText ? (
            <Typography variant={TypographyVariants.LEGAL_PRIMARY} key="field-helper" className="field-helper">
                {this.props.helperText}
            </Typography>
        ) : null;

        const errorText = this.state.error ? (
            <Typography variant={TypographyVariants.LEGAL_PRIMARY} key="error" className="field-error">
                {this.state.error}
            </Typography>
        ) : (
            helperText
        );

        return (
            <div key={this.props.id ? this.props.id : ''} className="percent-field">
                {this.props.label ? (
                    <Label htmlFor={this.props.id} className="percent-field-label">
                        {this.props.label}
                    </Label>
                ) : null}
                <Input
                    id={this.props.id}
                    className={`percent-text-field ${this.props.className ? this.props.className : ''} ${
                        this.state.error ? 'has-error' : ''
                    }  ${!this.props.textAlign || this.props.textAlign === 'left' ? 'align-percent-input-left' : ''}`}
                    value={this.props.value ? String(this.props.value).replace(/[^0-9.,]/g, '') : 0}
                    variant={this.props.variant || 'outlined'}
                    onFocus={(e: any) => e.target.select()}
                    onChange={this.onChange.bind(this)}
                    onKeyUp={this.props.onKeyUp ? this.props.onKeyUp.bind(this) : null}
                />
                {errorText}
            </div>
        );
    }

    private onChange(e: any): void {
        const value = Number(e.target.value.replace(/[^0-9.]/g, ''));

        if (e.target.value) {
            if (this.props.minValue && value < this.props.minValue) {
                if (this.errorTimer) {
                    clearTimeout(this.errorTimer);
                }
                this.errorTimer = window.setTimeout(() => {
                    this.setError(this.props.minError);
                }, 300);
            } else if (this.props.maxValue && value > this.props.maxValue) {
                if (this.errorTimer) {
                    clearTimeout(this.errorTimer);
                }
                this.errorTimer = window.setTimeout(() => {
                    this.setError(this.props.maxError);
                }, 300);
            } else {
                this.setState({
                    error: null
                });
                if (this.errorTimer) {
                    clearTimeout(this.errorTimer);
                }
            }
        } else {
            if (this.state.error) {
                if (this.errorTimer) {
                    clearTimeout(this.errorTimer);
                }
                this.setState({
                    error: null
                });
            }
        }

        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    private setError(error: string): void {
        this.setState({
            error
        });
    }
}
